@if (isNewDocument()) {
    <!-- 신규 문서 빈 상태 -->
    <section
        class="relative flex flex-col h-full items-center justify-center bg-gray-50"
    >
        <div class="flex flex-col items-center gap-4">
            <app-icon
                name="mdi:file-document-outline"
                class="text-gray-300 !size-16"
            />
            <div class="flex flex-col items-center gap-2">
                <p class="text-gray-600 text-lg font-medium">
                    아직 작성된 문서가 없습니다
                </p>
                @if (editRole()) {
                    <p class="text-gray-400 text-sm">
                        편집 버튼을 클릭하여 문서를 작성해주세요.
                    </p>
                } @else {
                    <p class="text-gray-400 text-sm">편집 권한이 없습니다.</p>
                }
            </div>
            @if (editRole()) {
                <app-button
                    (click)="handleEdit()"
                    icon="mdi:pencil"
                    class="mt-4"
                    >문서 작성 시작</app-button
                >
            }
        </div>
    </section>
} @else if (document(); as d) {
    @if (readRole()) {
        <section class="relative flex flex-col h-full">
            <div
                class="p-4 md:p-6 flex w-full justify-between border-b border-gray-200"
            >
                <div class="flex flex-col gap-2">
                    <div class="flex gap-2 items-center">
                        <p class="md:text-lg font-semibold text-gray-800">
                            {{ name() }}
                        </p>

                        @if (enableAi()) {
                            <div
                                class="flex gap-1 items-center ai-badge px-1.5 py-0.5"
                            >
                                <div class="flex gap-1 items-center">
                                    <app-icon
                                        name="mingcute:bling-fill"
                                        class="!size-3 text-primary"
                                    />
                                    <p class="text-primary text-sm">AI</p>
                                </div>
                            </div>
                        }
                    </div>
                    <div class="flex gap-3 items-center">
                        @if (d.updatedAt) {
                            <div class="flex gap-2 items-center">
                                <app-icon
                                    name="carbon:update-now"
                                    size="sm"
                                    class="text-gray-400"
                                />
                                <p class="text-gray-400 text-sm">
                                    {{ d.updatedAt | date: "y.MM.dd HH:mm" }}
                                    마지막 업데이트
                                </p>
                            </div>
                        } @else {
                            <p class="text-gray-400 text-sm">미작성</p>
                        }
                        @if (d?.centerUser?.username; as name) {
                            <div class="flex gap-2 items-center">
                                <div
                                    class="size-2 bg-primary rounded-full"
                                ></div>
                                <p class="text-sm text-gray-800">
                                    {{ name }}
                                </p>
                            </div>
                        }
                    </div>
                </div>
                <div class="hidden md:flex gap-2 items-center">
                    <app-button
                        (click)="handleShare()"
                        size="sm"
                        icon="ion:ios-share-alt"
                        color="gray"
                        variant="ghost"
                        >공유</app-button
                    >
                    <app-button
                        class="hidden lg:block"
                        (click)="handlePrint()"
                        icon="material-symbols:print-rounded"
                        size="sm"
                        color="gray"
                        variant="ghost"
                    >
                        인쇄
                    </app-button>
                    <app-button
                        (click)="handleDownload()"
                        icon="mdi:download"
                        size="sm"
                        color="gray"
                        variant="ghost"
                        [loading]="isLoading()"
                    >
                        다운로드
                    </app-button>
                    @if (editRole()) {
                        <app-button
                            (click)="handleEdit()"
                            variant="ghost"
                            icon="mdi:pencil"
                            color="gray"
                            size="sm"
                            >편집</app-button
                        >
                    }
                    @if (deleteRole()) {
                        <app-button
                            [disabled]="!values()"
                            (click)="handleDelete()"
                            variant="ghost"
                            icon="mdi:delete"
                            color="gray"
                            size="sm"
                            >삭제</app-button
                        >
                    }
                </div>
            </div>
            <div class="flex h-full">
                @if (useSideMenu()) {
                    <div
                        class="flex flex-col gap-3 w-[15rem] border-r h-full overflow-y-auto p-4 lg:pb-[10rem]"
                    >
                        <!-- 정렬 필터 추가 -->
                        <div class="flex gap-2 mb-1 px-1">
                            <button
                                (click)="sortType.set('latest')"
                                [class.text-primary]="sortType() === 'latest'"
                                [class.font-bold]="sortType() === 'latest'"
                                class="text-sm text-gray-400 hover:text-primary transition-colors"
                            >
                                최신순
                            </button>
                            <div class="w-[1px] h-2 bg-gray-200 mt-1"></div>
                            <button
                                (click)="sortType.set('oldest')"
                                [class.text-primary]="sortType() === 'oldest'"
                                [class.font-bold]="sortType() === 'oldest'"
                                class="text-sm text-gray-400 hover:text-primary transition-colors"
                            >
                                연도순
                            </button>
                        </div>

                        @for (item of sideMenuItems(); track $index) {
                            <div
                                (click)="handleSideMenuClick(item.id)"
                                [class]="
                                    item.id === documentId()
                                        ? 'border-primary text-primary bg-primary-50'
                                        : 'border-gray-200 hover:bg-gray-50 text-gray-500'
                                "
                                class="cursor-pointer p-3 py-2 border rounded-xl"
                            >
                                @if (
                                    document()?.inServiceType === "서비스일정표"
                                ) {
                                    {{ $any(item.data).year }}년
                                    {{ $any(item.data).month }}월
                                } @else {
                                    {{ $any(item.data).month }}
                                }
                            </div>
                        }

                        <app-button
                            expand
                            (click)="handleAdd()"
                            variant="outline"
                            color="gray"
                            icon="mdi:plus"
                        >
                            <p class="text-sm">추가</p></app-button
                        >
                    </div>
                }
                <div class="w-full h-full overflow-y-auto p-6 lg:pb-[10rem]">
                    <div
                        #documentSection
                        class="md:scale-100 scale-50 origin-top-left"
                    >
                        <ng-container *ngTemplateOutlet="content" />
                    </div>
                </div>
            </div>
        </section>
    } @else {
        @if (printMode()) {
            <ng-container *ngTemplateOutlet="content" />
        }
    }
}

<ng-template #content>
    @if (isPreDocument()) {
        <ng-container *ngTemplateOutlet="preTemplates" />
    } @else if (isInDocument()) {
        <ng-container *ngTemplateOutlet="inTemplates" />
    } @else if (isEtcDocument()) {
        <ng-container *ngTemplateOutlet="etcTemplates" />
    }
</ng-template>

<ng-template #preTemplates>
    @switch (name()) {
        @case (preType["기본상담지"]) {
            <app-default-counseling-template [values]="values()" />
        }
        @case (preType["심화상담지"]) {
            <app-advanced-counseling-template [values]="values()" />
        }
        @case (preType["평가보고서"]) {
            <app-evaluation-report-template [values]="values()" />
        }
        @case (preType["발달재활서비스의뢰서"]) {
            <app-development-rehabilitation-service-request-template
                [values]="values()"
            />
        }
        @case (preType["아동청소년심리서비스의뢰서"]) {
            <app-child-adolescent-service-request-template
                [values]="values()"
            />
        }
    }
</ng-template>

<ng-template #inTemplates>
    @switch (name()) {
        @case (inType["장단기계획서"]) {
            <app-term-treatment-plan-template [values]="values()" />
        }
        @case (inType["중간보고서"]) {
            <app-interim-report-template [values]="values()" />
        }
        @case (inType["종결보고서"]) {
            <app-interim-report-template [values]="values()" [isEnd]="true" />
        }
        @case (inType["발달재활서비스계약서"]) {
            <app-development-service-agreement-template [values]="values()" />
        }
        @case (inType["아청심서비스계약서"]) {
            <app-child-service-agreement-template [values]="values()" />
        }
        @case (inType["개인정보수집및이용동의서"]) {
            <app-private-info-agreement-template [values]="values()" />
        }
        @case (inType["서비스제공기록지"]) {
            <app-service-record-template [values]="values()" />
        }
        @case (inType["서비스일정표"]) {
            <app-service-schedule-template [values]="values()" />
        }
        @case (inType["발달재활서비스제공계획서"]) {
            <app-development-rehabilitation-service-plan-template
                [values]="values()"
            />
        }
    }
</ng-template>

<ng-template #etcTemplates>
    @switch (name()) {
        @case (etcType["변경계약서"]) {
            <app-change-contract-template [values]="values()" />
        }
        @case (etcType["사유서"]) {
            <app-reason-statement-template [values]="values()" />
        }
    }
</ng-template>
